import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router";
import dayjs from 'dayjs';
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container, FormLabel } from '@mui/material';
import Typescript from '@mui/material/Typography'
import Checkbox from '@mui/material/Checkbox';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Form, { Field } from 'rc-field-form';
import FormContext from 'rc-field-form/es/FormContext';
import TextField from '@mui/material/TextField';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import { MapContainer, TileLayer, useMap } from 'react-leaflet'

import Map from './Map'

import Dropzone from '../../components/Dropzone'
import Title from '../../components/Title'
import Text from '../../components/Text'
import AppLink from '../../components/AppLink'

import TextFeld from '../../components/TextFeld'
import AreaFeld from '../../components/AreaFeld'
import DateFeld from '../../components/DateFeld'
import AppCheckbox from '../../components/AppCheckbox'
import AppButton from '../../components/AppButton'
import SelectFeld from '../../components/SelectFeld';

function Formular() {

  const { t } = useTranslation();

  const init = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    birth: 0,
    place: "",
    date: "",
    description: "",
    category: 0,
    art: "",
    lon: 0,
    lat: 0,
    file1: "",
    file2: "",
    annotation: ""
  }

  const err = {
    firstname: false,
    lastname: false,
    email: false,
    phone: false,
    birth: false,
    place: false,
    date: false,
    description: false,
    category: false,
    art: false,
    lon: false,
    lat: false,
    file1: false,
    file2: false,
    annotation: false,
    dsgvo: false,
    copyright: false
  }

  const [data, setData] = useState(init)
  const [error, setError] = useState(err)

  const resetData = () => {
    setData(init)
  }

  const resetError = () => {
    setError(err)
  }

  const [filename1, setFilename1] = useState("File")
  const [filename2, setFilename2] = useState("File")

  const [dsgvo, setDsgvo] = useState(false)
  const [copyright, setCopyright] = useState(false)

  const [open, setOpen] = useState(false)
  const [errormessage, setErrormessage] = useState("")

  const handleClickOpen = () => {
    //setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const onDrop1 = useCallback((acceptedFiles) => {

    acceptedFiles.map((file) => {

      let reader = new FileReader();

      reader.onload = function (e) {
        console.log(e.target);
      };

      reader.readAsDataURL(file);

      reader.onload = function (e) {
        //console.log(e);
        setData((prevState) => ({ ...prevState, file1: e.target.result }));
        setFilename1(file.path);
      }

      return file;
    }); // map
  }, []);

  const onDrop2 = useCallback((acceptedFiles) => {

    acceptedFiles.map((file) => {
      let reader = new FileReader();

      reader.onload = function (e) {
        console.log(e.target);
      };

      reader.readAsDataURL(file);

      reader.onload = function (e) {
        //console.log(e.target);
        setData((prevState) => ({ ...prevState, file2: e.target.result }));
        setFilename2(file.path);
      }

      return file;
    }); // map
  }, []);


  const setPoint = ([a, b]) => {
    setData((prevState) => ({ ...prevState, lat: a, lon: b }))
    resetError();
  }

  const chechTextFeld = (name, field, error) => {

    if (field.length < 5) {
      const element = document.getElementById(name);
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, "{name}": true }))
      return true;
    }

    return false;
  }

  const handleDsgvo = (d) => {
    resetError();
    setDsgvo(d.target.checked)
  }
  const handleCopyright = (d) => {
    resetError();
    setCopyright(d.target.checked)
  }

  const resetFields = () => {

    setData(init);
    setFilename1("File");
    setFilename2("File");
    setDsgvo(false);
    setCopyright(false);
  }

  {/*   */ }
  const send = () => {

    console.log("Data:", data);

  
    if (data.firstname.length === 0) {
      const element = document.getElementById("firstname");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, firstname: true }))
      console.log("Error: ", "firstname");
      return true;
    }

    if (data.lastname.length === 0) {
      const element = document.getElementById("lastname");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, lastname: true }))
      console.log("Error: ", "lastname");
      return true;
    }


    if (data.email.length < 5) {
      const element = document.getElementById("email");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, email: true }))
      console.log("Error: ", "email");
      return true;
    }

    /*if (data.phone.length < 5) {
      const element = document.getElementById("phone");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, phone: true }))
      console.log ("Error: ", "phone");
      return true;
    }

    if (data.birth < 1900) {
      const element = document.getElementById("birth");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, birth: true }))
      console.log ("Error: ", "birth");
      return true;
    }*/

    if (data.place.length === 0) {
      const element = document.getElementById("place");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, place: true }))
      console.log("Error: ", "place");
      return true;
    }

    if (data.date.length === 0) {
      const element = document.getElementById("date");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, date: true }))
      console.log("Error: ", "date");
      return true;
    }

    if (data.description.length === 0) {
      const element = document.getElementById("description");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, description: true }))
      console.log("Error: ", "description");
      return true;
    }

    if (data.category === 0) {
      const element = document.getElementById("category");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, category: true }))
      console.log("Error: ", "category");
      return true;
    }

    if (data.art.length === 0) {
      const element = document.getElementById("art");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, art: true }))
      console.log("Error: ", "art");
      return true;
    }

    if (data.lon === 0 || data.lat === 0) {
      const element = document.getElementById("lon");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, lon: true }))
      setError((prevState) => ({ ...prevState, lat: true }))
      console.log("Error: ", "lon");
      return true;
    }

    if (filename1 === "File") {
      console.log("Error: ", "filename1");
      const element = document.getElementById("filename");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, file1: true }))
      return true;
    }

    if (filename2 === "File") {
      console.log("Error: ", "filename2");
      const element = document.getElementById("filename");
      element.scrollIntoView();
      setError((prevState) => ({ ...prevState, file2: true }))
      return true;
    }

    if (dsgvo === false)
      setError((prevState) => ({ ...prevState, dsgvo: true }))
    if (copyright === false)
      setError((prevState) => ({ ...prevState, copyright: true }))


    if (dsgvo === false)
      setError((prevState) => ({ ...prevState, dsgvo: true }))
    if (copyright === false)
      setError((prevState) => ({ ...prevState, copyright: true }))

    if (dsgvo === false || copyright === false)
      return;


    fetch("https://phytowatch.laimburg.it/phytoplasma.php", {
      method: 'POST',
      mode: 'cors',
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data'
      },
      body: JSON.stringify(data)
    })
      .then((response) => {
        switch (response.status) {
          case 417:
            //setDialogerror(true);
            //const element = document.getElementById("email");
            //element.scrollIntoView();
            setErrormessage("417");
            //setOpen(true);

            break;
          case 200:
            //setDialog(true);
            //setFine(true);
            
            setOpen(true)
            resetFields();

            break;
          default:
            setErrormessage(response.status);
          //setOpen(true);
        }
        //setSnak(false)
      })


    /*
    if (chechTextFeld("email", data.email, error.email)) return;
    if (chechTextFeld("phone", data.phone, error.phone)) return;
    if (chechTextFeld("birth", data.birth, error.birth)) return;

    if (chechTextFeld("place", data.place, error.place)) return;
    if (chechTextFeld("date", data.date, error.date)) return;
    if (chechTextFeld("description", data.description, error.description)) return;
    if (chechTextFeld("category", data.category, error.category)) return;
    if (chechTextFeld("art", data.art, error.art)) return;
    if (chechTextFeld("lat", data.lat, error.lat)) return;
    if (chechTextFeld("lon", data.lon, error.lon)) return;
    if (chechTextFeld("file1", data.file1, error.file1)) return;
    if (chechTextFeld("file2", data.file2, error.file2)) return;
    if (chechTextFeld("annotation", data.annotation, error.annotation)) return;
    */
  }



  return (

    <>
      <FormGroup>
        <Container className="bgwhite dist">

          <Title text="formular_1_title" color="orange" variant="normal" />

          <AppLink text="formular_1_link" url="/phyto" color="black" variant="normal" />
          <Text text="formular_1_text" color="black" variant="normal" />
          <AppLink text="formular_2_link" url="/phyto" color="black" variant="normal" />
          <Text text="formular_2_text" color="black" variant="normal" />

        </Container>

        <Container className="bggreen py-3">

          <Title text="formular_2_title" color="orange" variant="normal" />

          <Grid container justifyContent={'space-between'} rowSpacing={0} spacing={5}>

            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <TextFeld
                id={"firstname"}
                val={data.firstname}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, firstname: i })) })}
                text="formular_vorname"
                color="white"
                error={error.firstname}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <TextFeld
                id={"lastname"}
                val={data.lastname}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, lastname: i })) })}
                text="formular_nachname"
                color="white"
                error={error.lastname}
              />
            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'} rowSpacing={0} spacing={5}>

            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <TextFeld
                id={"email"}
                val={data.email}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, email: i })) })}
                text="formular_email"
                color="white"
                error={error.email}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <TextFeld
                id={"phone"}
                val={data.phone}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, phone: i })) })}
                text="formular_phone"
                color="white"
                error={error.phone}
              />
            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'} rowSpacing={0} spacing={5}>

            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <TextFeld
                id={"birth"}
                val={data.birth}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, birth: i })) })}
                text="formular_birth"
                color="white"
                type='number'
                error={error.birth}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            </Grid>

          </Grid>

        </Container>


        <Container className="bgwhite dist">

          <Title text="formular_3_title" color="orange" variant="normal" />

          <Grid container justifyContent={'space-around'} rowSpacing={0} spacing={5} >

            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <TextFeld
                id={"place"}
                val={data.place}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, place: i })) })}
                text="formular_standort"
                color="black"
                error={error.place}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <DateFeld
                id={"date"}
                val={data.date}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, date: dayjs(i).format("YYYY-MM-DD") })) })}
                text="formular_date"
                type="date"
                error={error.date}
              />
            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'}>

            <Grid size={{ xs: 12, sm: 12 }}>
              <AreaFeld
                id={"description"}
                val={data.description}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, description: i })) })}
                text="formular_beschreibung"
                color="black"
                error={error.description}
              />
            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'}>

            <Grid size={{ xs: 12, sm: 12 }}>
              <SelectFeld
                id={"category"}
                val={data.category}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, category: i })) })}
                text="formular_categorie"
                color="black"
                error={error.category}
              />
            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'}>

            <Grid size={{ xs: 12, sm: 12 }}>
              <TextFeld
                id={"art"}
                val={data.art}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, art: i })) })}
                text="formular_arte"
                color="black"
                error={error.art}
              />
            </Grid>

          </Grid>

          <Grid className="row" container justifyContent={'space-around'}>

            <Text text="formular_zoom" color="black" variant="normal" />
            <Grid size={{ xs: 12, sm: 12, md: 8 }}>

              <div className="map">
                <Map setter={setPoint} />
              </div>

            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'} rowSpacing={0} spacing={5} >

            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <TextFeld
                id={"lat"}
                val={data.lat}
                text="formular_lon"
                callback={() => { }}
                color="black"
                error={error.lat}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <TextFeld
                id={"lon"}
                val={data.lon}
                text="formular_lat"
                callback={() => { }}
                color="black"
                error={error.lon}
              />
            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'} spacing={5} >

            <Grid size={{ xs: 12, sm: 12, md: 6 }} id="filename" >

              <Dropzone
                id="filename1"
                onDrop={onDrop1}
                accept={"images/*"}
                label="formular_picture_1"
                color="primary"
                filename={filename1}
                error={error.file1}
                open={((i) => { resetError() })}
              />

              {/* 
              <TextFeld
                id={""}
                text="formular_picture_1"
                color="black"
                callback={((i) => { console.log(i) })}
                val={data.file1}
                type="file"
              />
              */}

            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 6 }}>

              <Dropzone
                id="filename2"
                onDrop={onDrop2}
                accept={"images/*"}
                label="formular_picture_2"
                color="primary"
                filename={filename2}
                error={error.file2}
                open={((i) => { resetError() })}
              />

              {/* 
              <TextFeld
                id={2}
                text="formular_picture_2"
                color="black"
                callback={((i) => { console.log(i) })}
                val={data.file2}
                type="file"
              />
              */}
            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'} spacing={5} >

            <Grid size={{ xs: 12, sm: 12 }}>
              <AreaFeld
                id={"annotation"}
                val={data.annotation}
                callback={((i) => { resetError(); setData((prevState) => ({ ...prevState, annotation: i })) })}
                text="formular_anmerkung"
                color="black"
              />
            </Grid>

          </Grid>

          <Grid container justifyContent={'space-around'} spacing={5} className="dist">

            <Grid size={{ xs: 12, sm: 12, md: 9 }}>
              <div>
                <FormControlLabel
                  required
                  control={<Checkbox value={dsgvo} onChange={handleDsgvo} />}
                  error={error.dsgvo}
                  label={<FormLabel error={error.dsgvo}>{t("formular_required")}</FormLabel>}
                />

                <a href="/Informativa privacy PhytoWatch 2026.pdf" target="_blank">
                  <Button variant="outlined" color="green">PDF</Button>
                </a>
              </div>
              <div>
                <FormControlLabel
                  required
                  control={<Checkbox value={copyright} onChange={handleCopyright} />}
                  error={error.copyright}
                  label={<FormLabel error={error.copyright}>{t("copyright")}</FormLabel>}
                />

                <a href="/liberatoria foto.pdf" target="_blank">
                  <Button variant="outlined" color="green">PDF</Button>
                </a>
              </div>
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 3 }}>
              <AppButton callback={send} />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12 }}>

            </Grid>

          </Grid>

        </Container>

      </FormGroup>

    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogTitle id="alert-dialog-title">
          {t("success_title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("success_text_1")}
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            {t("success_text_2")}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>

      </Dialog>
    </React.Fragment>
   

    </>

  );
}

export default Formular;
